import { DATA_HOOKS } from './Skeleton.constants';
import { deprecationTestkitLog } from '../utils/deprecationTestkitLog';

const selector = element => hook =>
  element.querySelectorAll(`[data-hook="${hook}"]`);

export const SkeletonDriver = ({ element }) => {
  deprecationTestkitLog(
    'skeletonTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the SkeletonTestkit unidriver testkit instead.',
  );
  const byHook = selector(element);

  return {
    exists: () => !!element,

    /** return number of lines rendered */
    getNumLines: () => byHook(DATA_HOOKS.line).length,

    /** return boolean representing whether given spacing is rendered */
    hasSpacing: spacing => element.getAttribute('data-spacing') === spacing,

    /** return boolean representing whether given list of sizes is rendered */
    hasSizes: sizes => {
      const [assertions] = Array.from(byHook(DATA_HOOKS.chunk)).reduce(
        ([result, [expectedSize, ...restSizes]], chunkElement) => [
          result.concat(
            chunkElement.getAttribute('data-size') === expectedSize,
          ),
          restSizes,
        ],
        [[], sizes],
      );

      return assertions.every(Boolean);
    },

    /** return boolean representing whether given alignment is rendered */
    hasAlignment: alignment =>
      element.getAttribute('data-alignment') === alignment,
  };
};
